#checkmark-group {
    width: 24px;
}

#checkmark {
    fill: none;
    stroke: green;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width:3px;
    stroke-dasharray: 200;
    animation: checkmark-stroke 2s infinite linear;
    stroke-linejoin: round;
    /* opacity: 0; */
}

@keyframes checkmark-stroke {
    0% {
        stroke-dashoffset: 200;
        /* opacity: 1; */
    }

    100% {
        stroke-dashoffset: 0;
        /* opacity: 1; */
    }
}